<!--
 * @Author: your name
 * @Date: 2021-09-03 09:58:52
 * @LastEditTime: 2021-09-10 17:48:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/buyFoot.vue
-->
<!--  -->
<template>
  <div class="buy-foot">
    <div v-show="!$root.zsbMini">
      <!--  售前-->
      <ToBuy v-if="!buyStatus" v-bind="$attrs" v-on="$listeners" />
      <!-- 售后 -->
      <ToStudy v-else v-bind="$attrs" />
    </div>
    <div v-show="$root.zsbMini">
      <!--  售前-->
      <ZsbToBuy v-if="!buyStatus" v-bind="$attrs" v-on="$listeners" />
      <!-- 售后 -->
      <ZsbToStudy v-else v-bind="$attrs" />
    </div>
  </div>
</template>

<script>
import ToBuy from './toBuy.vue';
import ToStudy from './toStudy.vue';
import ZsbToBuy from './zsbToBuy.vue';
import ZsbToStudy from './zsbToStudy.vue'

export default {
  components: {
    ToBuy,
    ToStudy,
    ZsbToBuy,
    ZsbToStudy,
  },
  props: {
    buyStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    async getPageDetail() {
      await this.$parent.getDeatil();
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-foot {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
